import type { FaireProductEntity } from "../../entity_types/product";

export const p_n3sxe78y4s: FaireProductEntity = {
  token: "p_n3sxe78y4s",
  type: "product",
  name: "Solid Silk Satin Sleeping Mask Eye Mask",
  brandName: "Love and Repeat",
  imageUrl:
    "https://cdn.faire.com/fastly/1b555b06ee416d1c9a19da1f0d3cc11019c898298d004dca087612ab65ae8d43.jpeg",
  priceDollars: 1.75,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/c89b2d3d847a6ace06426b7d8715b82d409a50270271968d72dbd3669b06ac0d.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
